import { Component, Input, OnInit, inject } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { finalize } from 'rxjs/operators';
import { CoachService } from '../../_core/services/coach.service';
import { ToastService } from '../../_core/services/toast.service';
import { Coach } from '../../_shared/models/coach.model';
import { TranslateService } from '@ngx-translate/core';

interface ImageUploadedData {
  image: any;
  imageChanged: boolean;
}
@Component({
  selector: 'app-add-coach',
  templateUrl: './create-coach.component.html',
  styleUrls: ['./create-coach.component.scss'],
  standalone: false
})
export class CreateCoachComponent implements OnInit {
  @Input() coach: Coach;
  @Input() editModal: boolean;

  form: UntypedFormGroup;
  submittingForm = false;
  isEdit = false;
  private _userImage: ImageUploadedData;
  constructor(
    private coachService: CoachService,
    private fb: UntypedFormBuilder,
    private modalCtrl: ModalController,
    private toastService: ToastService,
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    !this.coach ? (this.coach = new Coach()) : (this.isEdit = true);
    this.buildForm();
  }

  buildForm() {
    this.form = this.fb.group({
      first_name: [
        this.coach.first_name,
        [Validators.required, Validators.minLength(1)],
      ],
      last_name: [
        this.coach.last_name,
        [Validators.required, Validators.minLength(1)],
      ],
      sex: [this.coach?.gender],
      
    })
  }  


  dismiss() {
    this.modalCtrl.dismiss();
  }

  async submit() {
    if (this.form.valid) {
      this.submittingForm = true;

      const formData = new FormData();
      Object.keys(this.form.value).forEach((key) => {
        formData.append(key, this.form.get(key)?.value || '');
      }
      );
      // Handle profile_image if it's available
      if (this._userImage?.image) {
        const blob = await fetch(this._userImage?.image).then((res) =>
          res.blob()
        );
        formData.append('profile_image', blob);
      } else {
        formData.append('profile_image', ''); // Add empty string if no image
      }
      formData.append('isImageChange', (this._userImage?.imageChanged || false).toString());
      if (!this.isEdit) {
        this.coachService
          .create(formData)
          .pipe(finalize(() => (this.submittingForm = false)))
          .subscribe(
            (res) => {
              this.toastService.presentToast(res.message);
              this.modalCtrl.dismiss(res.data);
            },
            (err) => {
              //console.log(err)
            }
          );
      } else {
        this.coachService
          .update(this.coach._id, formData)
          .pipe(finalize(() => (this.submittingForm = false)))
          .subscribe(
            (res) => {
              this.modalCtrl.dismiss({
                ...this.coach,
                ...res.data, 
              });
            },
            (err) => {
              //console.log(err)
            }
          );
      }
    } else {
      this.handleErrors();
    }
  }

  handleErrors() {
    let errorMessage = '';
    if (this.form.get('first_name')?.invalid) {
      errorMessage = this.translateService.instant('First name is required.');
    } else if (this.form.get('last_name')?.invalid) {
      errorMessage = this.translateService.instant('Last name is required.');
    }
    this.toastService.presentDangerToast(errorMessage);
  }

  close() {
    this.modalCtrl.dismiss();
  }

  clear() {
    this.form.reset();
  }

  imageSelected(data: ImageUploadedData) {
    this._userImage = data;
  }
}
